import { useState, useRef, useEffect } from "react";
import { Input } from 'antd';
import { Services } from '../../__services';
import { ModalComponent, SpinnerComponent, TableComponent } from "../../Component/Common";
import { SearchBarWrapper } from "./style";
import { getFromDB, decryptData } from '../../Utils';
let timer;


export const PatientSearch = ({ onClick }) => {
    const [spinner, setSpinner] = useState(false);
    const [allPatient, setAllPatient] = useState([]);
    const [filteredPatient, setFilteredPatient] = useState([]);

    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false
            loadFromDB();
            return;
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const onChangeHandler = (type, value) => {
        if (['patient_identifier', 'name'].includes(type)) {
            filterPatient(type, value);
        }
    }

    const loadFromDB = async () => {
        const cached = await getFromDB('visit');
        if (cached) {
            const decrypted = await decryptData(cached);
            if (decrypted && typeof decrypted === 'object' && decrypted.hasOwnProperty('data') && decrypted.hasOwnProperty('date')) {
                let allPatient = decrypted.data
                setAllPatient(allPatient);
                setFilteredPatient(allPatient);
            }
        };
    }

    const getPatientsWithPatientId = (value, timing) => {
        try {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setSpinner(true);
                let params = ``;
                params += `patient_identifier=Like(${value})&customQuery=person,visits(location)`;
                Services.GetPatientWithParams(params).then(response => {
                    if (response.rows?.length) {
                        let allSearchablePatient = response.rows.map(pt => {
                            return {
                                key: pt?.visits[0]?.id,
                                patient_id: pt?.id,
                                patient_identifier: pt?.patient_identifier,
                                abha_no: pt?.abha_no,
                                name: `${pt.person?.first_name} ${pt?.person?.middle_name || ''} ${pt?.person?.last_name}`,
                                gender: pt?.person?.gender,
                                dob: pt?.person?.birthdate,
                                created_at: pt?.visits[0]?.created_at,
                                location: pt?.visits[0]?.location?.name,
                            }
                        }
                        );
                        setSpinner(false);
                        setFilteredPatient(allSearchablePatient);
                        // setAllPatient(allSearchablePatient);
                    } else {
                        setSpinner(false);
                        setFilteredPatient([]);
                    }
                })
            }, timing);
        } catch (e) {
            console.log('Get Patient Exception: ', e);
        }
    }

    const getPatientsWithPatientName = (value, timing) => {
        try {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setSpinner(true)
                let name = value.split(' ');
                let params = ``;
                params += `first_name=Like(${name[0]})&customQuery=patient,patient.visits(location)`;
                Services.GetPersonWithParams(params).then(response => {
                    if (response.rows?.length) {
                        let allSearchablePatient = response.rows.map(pt => {
                            return {
                                key: pt?.patient?.visits[0]?.id,
                                patient_id: pt?.patient?.id,
                                patient_identifier: pt?.patient?.patient_identifier,
                                abha_no: pt?.patient?.abha_no,
                                name: `${pt?.first_name} ${pt?.middle_name || ''} ${pt?.last_name}`,
                                gender: pt?.gender,
                                dob: pt?.birthdate,
                                created_at: pt?.patient?.visits[0]?.created_at,
                                location: pt?.patient?.visits[0]?.location?.name,
                            }
                        }
                        );
                        setSpinner(false);
                        setFilteredPatient(allSearchablePatient);
                        // setAllPatient(allSearchablePatient);
                    } else {
                        setSpinner(false);
                        setFilteredPatient([]);
                    }
                })
            }, timing);
        } catch (e) {
            console.log('Get Patient Exception: ', e);
        }
    }

    const filterPatient = (type = 'patient_identifier', value = '') => {
        try {
            let lowercasedFilter = value !== undefined ? value.toString().toLowerCase() : '';
            let filteredData = allPatient.filter(item => item[type]?.toString().toLowerCase().includes(lowercasedFilter));
            if (!filteredData.length) {
                type === 'patient_identifier' ? getPatientsWithPatientId(value, 2000) : getPatientsWithPatientName(value, 2000);
                return;
            }
            setFilteredPatient(filteredData);
            setSpinner(false);
        } catch (e) {
            console.log('Filter Patient Exception: ', e);
        }
    }

    return (
        <>
            <ModalComponent
                width='900px'
                open={true}
                title='Patient Search'
                onCancel={() => onClick('showPatientSearch', false)}
                saveData={() => onClick('showPatientSearch', false)}>
                <SearchBarWrapper>
                    <Input
                        placeholder="Search with Patient Id"
                        size='large'
                        style={{ width: 300 }}
                        allowClear
                        enterButton="Search"
                        onChange={(e) => onChangeHandler('patient_identifier', e.target.value)} />
                    <Input
                        placeholder="Search with Patient Name"
                        size='large'
                        style={{ width: 300 }}
                        allowClear
                        enterButton="Search"
                        onChange={(e) => onChangeHandler('name', e.target.value)} />
                </SearchBarWrapper>
                {spinner ?
                    <SpinnerComponent /> :
                    <>
                        <br />
                        <br />
                        <TableComponent search={true} data={filteredPatient} rowPerPage='5' />

                    </>
                }
            </ModalComponent>
        </>
    )
}